import apiWarehouse from '@/services/api/warehouse';

export default {
    namespaced: true,
    state: {
        warehouseVerifyPermissions: null,
        warehouseData: null,
        familiesInWarehouse: [],
        familiesInWarehouseAmount: null,
        hasStreet: null
    },
    getters: {
        getWarehouseVerifyPermissions: (state) => state.warehouseVerifyPermissions,
        getWarehouse (state) {
            return state.warehouseData;
        },
        getFamiliesInWarehouse: (state) => state.familiesInWarehouse,
        getFamiliesInWarehouseAmount: (state) => state.familiesInWarehouseAmount,
        getHasStreet: (state) => state.hasStreet
    },
    mutations: {
        setWarehouseVerifyPermissions (state, data) {
            state.warehouseVerifyPermissions = data;
        },
        setWarehouse (state, payload) {
            state.warehouseData = payload;
        },
        setFamiliesInWarehouse (state, data) {
            state.familiesInWarehouse = data;
        },
        setFamiliesInWarehouseAmount (state, data) {
            state.familiesInWarehouseAmount = data;
        },
        setHasStreet (state, payload) {
            state.hasStreet = payload;
        }
    },
    actions: {
        acceptWarehouse (context, id) {
            return apiWarehouse.acceptWarehouse(id);
        },
        getWarehouse (context, payload) {
            const _data = {
                warehouseId: payload.warehouseId
            };
            if (context.rootGetters['warehouses/getWarehouseWasEdited']) {
                _data.params = new URLSearchParams();
                _data.params.append('force_refresh', '1');
            }
            return apiWarehouse.getWarehouse(_data).then(({ data }) => {
                context.commit('setWarehouse', data.data);
                context.commit('setWarehouseVerifyPermissions', data.permissions);
                if (payload.isForm !== true) {
                    return data.data;
                }
                const warehouse = data.data;
                const response = {
                    baseInfo: {
                        ...warehouse.warehouse_data.base_info
                    },
                    locationData: {
                        warehouseName: warehouse.warehouse_name,
                        address: {
                            locationName: warehouse.location_name,
                            street: warehouse.street,
                            city: warehouse.city,
                            flatNumber: warehouse.flat_number,
                            placeNumber: warehouse.building_number,
                            province: warehouse.province.province_id,
                            rejon: warehouse.wio_struct_location_id,
                            postalCode: warehouse.postal_code
                        },
                        openingHours: {
                            ...warehouse.warehouse_data.location_data.opening_hours
                        },
                        directions: warehouse.warehouse_data.location_data.directions
                    },
                    additionalParameters: {
                        ...warehouse.warehouse_data.additional_parameters
                    },
                    warehouseManager: {
                        ...warehouse.warehouse_data.warehouse_manager,
                        manager: warehouse.warehouse_manager.id,
                        full_name: warehouse.warehouse_manager.full_name
                    },
                    additionalNote: warehouse.warehouse_data.additional_note
                };

                const street = response.locationData.address.street;
                if (street === null) {
                    response.locationData.address.street = false;
                }
                context.commit('warehouses/setSupportingWarehouseData', response, { root: true });
                context.commit('warehouses/setMergedAddress', response.locationData.address, { root: true });
                context.commit('warehouses/setMergedHours', response.locationData.openingHours, {
                    root: true
                });
                context.commit('warehouses/setMergedDirections', response.locationData.directions, {
                    root: true
                });
                context.commit('warehouses/setMergedAdditionalNote', response.additionalNote, {
                    root: true
                });
                return data.data;
            });
        },
        getFamiliesPerWarehouse (context, data) {
            return apiWarehouse.getFamiliesPerWarehouse(data).then((data) => {
                context.commit('setFamiliesInWarehouse', data.data.data);
                context.commit('setFamiliesInWarehouseAmount', data.data.amount);
            });
        }
    }
};
